import { AxiosResponse } from 'axios';
import { appContextGet } from './httpCommon/appAxios.service';
import { TANK_MAINTENANCE_CUSTOM_DATA_KEYS_ENDPOINTS } from '../constants/apiEndpoints';
import { PagedResponse, StandardParams } from '../types/interfaces';
import { TankMaintenanceCustomDataKey } from '../types/interfaces/accountTankMaintenance.interfaces';

export const getTankMaintenanceCustomDataKeys = (
  params?: StandardParams,
): Promise<AxiosResponse<TankMaintenanceCustomDataKey[] | PagedResponse<TankMaintenanceCustomDataKey>>> => {
  return appContextGet(TANK_MAINTENANCE_CUSTOM_DATA_KEYS_ENDPOINTS.BASE, params);
};
